import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ax from "../../config/axios";
import versionService, { RELEASE_NOTES } from "../../services/versionService";
import ReleaseNotesModal from "./ReleaseNotesModal";

import volImage from "../../assets/Volatility_Analysis_thumbnail.png";
import cotImage from "../../assets/COT_Analysis_thumbnail.png";
import correlImage from "../../assets/Correlation_thumbnail.png";

import styles from "./Dashboard.module.css";

function Dashboard() {
  const navigate = useNavigate();
  const [badges, setBadges] = useState(null);
  const currentVersion = versionService.getCurrentVersion();
  const [showModal, setShowModal] = useState(
    () =>
      !!RELEASE_NOTES[currentVersion] &&
      versionService.shouldShowReleaseNotes(currentVersion),
  );

  useEffect(() => {
    if (showModal) versionService.setLastSeenVersion(currentVersion);
  }, []);

  useEffect(() => {
    ax.get("/data/health-status").then((response) => {
      setBadges(response.data);
    });
  }, []);

  return (
    <div>
      <div className="d-flex flex-row flex-wrap justify-content-center gap-3 py-3 pb-5">
        {/* Vol Button Component */}
        <div
          className={`card h-auto ${styles.scale_on_click}`}
          style={{ width: "auto", maxWidth: 750 }}
          onClick={() => navigate("/volatility-analysis")}
        >
          <div className="card-header fw-bolder fs-4">Volatility Analysis</div>
          <div
            className="card-body d-flex  align-items-center p-2"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <img
              className="w-100 user-select-none"
              draggable={false}
              alt=""
              src={volImage}
            />
          </div>
          <div className="card-footer" />
        </div>

        {/* COT Button Component */}
        <div
          className={`card h-auto ${styles.scale_on_click}`}
          style={{ width: 500 }}
          onClick={() => navigate("/COT-analysis")}
        >
          <div className="card-header  fw-bolder fs-4">
            Commitment of Traders Analysis
          </div>
          <div
            className="card-body p-2 d-flex align-items-center"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <img
              className="w-100 user-select-none"
              draggable={false}
              alt=""
              src={cotImage}
            />
          </div>
          <div className="card-footer" />
        </div>

        {/* COT Button Component */}
        <div
          className={`card h-auto ${styles.scale_on_click}`}
          style={{ width: 500 }}
          onClick={() => navigate("/correlation")}
        >
          <div className="card-header  fw-bolder fs-4">
            Correlation Heatmaps
          </div>
          <div
            className="card-body p-2 d-flex align-items-center"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <img
              className="w-100 user-select-none"
              draggable={false}
              alt=""
              src={correlImage}
            />
          </div>
          <div className="card-footer" />
        </div>
      </div>
      {badges && (
        <div
          className="position-fixed bottom-0 start-0 w-100 bg-dark py-1"
          style={{ height: "3%" }}
        >
          <div className="d-flex gap-2 justify-content-center align-items-center h-100">
            {Object.keys(badges).map((key) => (
              <img className="h-100" key={key} src={badges[key]} alt={key} />
            ))}
            <span
              title="The data for this system is managed using a set of daily tasks and is monitored with these badges. If a badge is red for a service you are using, contact the developer."
              className="text-white"
              style={{
                textDecoration: "underline",
                cursor: "help",
              }}
            >
              <h6 className="text-white m-0">What is this?</h6>
            </span>
          </div>
        </div>
      )}

      {showModal && (
        <ReleaseNotesModal
          onDismiss={() => setShowModal(false)}
          releaseNotes={{
            version: currentVersion,
            ...RELEASE_NOTES[currentVersion],
          }}
        />
      )}
    </div>
  );
}

export default Dashboard;
